/**
 *
 * leave request Page
 *
 */
import Select from "react-select"
import React, { useState, useEffect } from "react"
import MetaTags from "react-meta-tags"
import PropTypes from "prop-types"
import { Table } from "reactstrap"
import Modal from "react-bootstrap/Modal"
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  CardBody,
  Label,
  Badge,
  Input,
  Spinner,
} from "reactstrap"
import moment from "moment"
import { withRouter, Link } from "react-router-dom"
import { connect, useDispatch } from "react-redux"
import { useSelector } from "react-redux"
import { isEmpty } from "lodash"
//Import Styles
import "./styles.scss"
import ButtonSpinner from "../../components/ButtonSpinner"
//date format
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
  PaginationTotalStandalone,
} from "react-bootstrap-table2-paginator"
import { ReactSearchAutocomplete } from "react-search-autocomplete"
import ToolkitProvider from "react-bootstrap-table2-toolkit"
// import { CSVExport } from "react-bootstrap-table2-toolkit"
//Components
import * as assignedEcAction from "../../store/ZWNBc3NpZ25lZExpc3Q/actions"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import * as permissionAction from "../../store/cGVybWlzc2lvbg/actions"
import { ToastContainer } from "react-toastify"
import api from "helpers/Api"

const EcAssignedList = (props) => {
  const title = "EC Assigned List"

  const { searchBarStyle, dispatch, location } = props
  // const { SearchBar } = Search
  // //console.log(location, "location")

  const specificDispatch = useDispatch()

  useEffect(() => {
    dispatch(assignedEcAction.loadRecordsMetaData())
    // setTimeout(() => {
    dispatch(
      assignedEcAction.loadAssignedEcList({
        // isManageEC: false,
        page: 1,
        limit: 50,
      })
    )
    // }, 1000)
    setDownloadLoading(true)
    setTimeout(() => {
      setDownloadLoading(false)
    }, 2000)
    dispatch(permissionAction.loadEmployee())
  }, [])

  //State manage details
  const update = useSelector((specificstate) => specificstate.ecAssignedList)
  const { recordsMetaData = {}, assigned_details = [] } = update

  const permissionUpdate = useSelector(
    (specificstate) => specificstate.permissionrequest
  )
  const { employee_list = [] } = permissionUpdate
  const sessionUpdate = useSelector((specificstate) => specificstate.session)

  const { user = [] } = sessionUpdate

  //Date format
  const dateSetting =
    !isEmpty(user) && user.setting && user.setting.dateFormate
      ? user.setting.dateFormate.toUpperCase()
      : []

  // const dateFormate = !isEmpty(dateSetting) && dateSetting ? dateSetting : ""

  //EMployee list

  const employeeList =
    !isEmpty(employee_list) &&
    employee_list.map((employee) => {
      return {
        _id: employee._id,
        empCode: employee.empCode,
        name: employee.name,
        companyId: employee.companyId,
        departmentId: employee.departmentId,
        roleId: employee.roleId,
      }
    })
  // //console.log(employeeList, "employeeee list")
  // //console.log(employee_list, "employee_list")

  // const employeeListDetails =
  //   !isEmpty(employeeList) && employeeList
  //     ? employeeList.filter((data) => data !== undefined)
  //     : []

  // //console.log(employeeListDetails, "employeeListDetails")
  const createOptions = (array) => {
    const options = []
    !isEmpty(array) &&
      array.forEach((element) => {
        const labelEmployee =
          element && element.empCode.concat(" - ", element.name)
        // [...element.empCode,...element.name].join('')
        const data = !isEmpty(element) ? element : []
        let obj = {}
        obj.value = data._id
        obj.label = labelEmployee
        obj.empCode = data.empCode
        obj.companyId = data.companyId
        obj.roleId = data.roleId
        options.push(obj)
      })
    return options
  }

  const agentOptions = createOptions(employeeList)

  // //console.log(agentOptions, "agentOptions")
  //fuse options in venue name
  const fuseOptions = {
    keys: ["empCode", "label"],
  }

  // //console.log("mod", modeldata)
  const [btnLoader, setBtnLoader] = useState(false)
  const [assignedData, setAssignedData] = useState({
    company: [],
    branch: [],
    department: [],
    fromDate: "",
    toDate: "",
    leadNo: "",
  })

  //handle Change
  const handleChange = async (e) => {
    setAssignedData({ ...assignedData, [e.target.name]: e.target.value })
  }

  // //console.log("assigned_details", assigned_details)
  //Filter dropdown list
  const [companies, setCompanies] = useState([])
  const [branches, setBranches] = useState([])
  const [events, setEvents] = useState([])
  const [salesAgent, setSalesAgent] = useState([])

  //dropdown options api

  const handleCompanies = (e) => {
    setCompanies(e)
    setBranches([])
  }

  const company =
    !isEmpty(companies) && companies.map((company) => company.value)
  const branch = !isEmpty(branches) && branches.map((branch) => branch.value)
  const branchOptions =
    !isEmpty(recordsMetaData) &&
    recordsMetaData.branchOptions.filter(
      (branch) =>
        branch.companyId ===
        companies.map((company) => company.value).toString()
    )
  // //console.log("branches", branchOptions)
  // //console.log(company, branch, "dropdown outputs")

  //Pagination states
  const [pageCount, setPageCount] = useState("")
  const [btnLoading, setBtnLoading] = useState(false)
  const [downloadLoading, setDownloadLoading] = useState(false)
  const [pageLoad, setPageLoad] = useState(false)
  const [searchInput, setSearchInput] = useState("")
  const [pageChange, setPageChange] = useState(false)

  //Modal Section States
  const [followupModal, setFollowupModal] = useState(false)
  const handleFollowupClose = () => setFollowupModal(false)
  const [followupDetails, setFollowupDetails] = useState("")

  const [checklistModal, setChecklistModal] = useState(false)
  const handleChecklistClose = () => setChecklistModal(false)
  const [checklistDetails, setChecklistDetails] = useState("")

  const [teamModal, setTeamModal] = useState(false)
  const handleTeamClose = () => setTeamModal(false)
  const [teamDetails, setTeamDetails] = useState("")

  const [equipmentModal, setEquipmentModal] = useState(false)
  const handleEquipmentClose = () => setEquipmentModal(false)
  const [equipmentDetails, setEquipmentDetails] = useState("")

  const [searchValue, setSearchValue] = useState({
    fromDate: "",
    toDate: "",
  })
  // //console.log(searchValue, "searchValue")
  // //console.log(equipmentDetails, "equipmentDetails")
  //Apply filter
  const handleFilter = (e) => {
    e.preventDefault()
    var searchCompany = companies && companies ? company : ""
    var searchBranch = branches && branches ? branch : ""
    var searchEvent = events && events ? events.value : ""
    var searchAgent = salesAgent && salesAgent ? salesAgent.value : ""
    // var searchPaymentStatus =
    //   paymentStatus && paymentStatus ? paymentStatus.value : ""
    var searchFromDate =
      assignedData && assignedData.fromDate
        ? moment(assignedData.fromDate).format("YYYY-MM-DD")
        : ""
    var searchToDate =
      assignedData && assignedData.toDate
        ? moment(assignedData.toDate).format("YYYY-MM-DD")
        : ""
    var searchLeadNo =
      assignedData && assignedData.leadNo ? assignedData.leadNo : ""

    var searchvalue = {}
    // searchvalue.isManageEC = false
    searchvalue.page = pageChange ? pageCount : 1
    searchvalue.limit = 50
    if (searchCompany) {
      searchvalue.companyId = searchCompany
    }
    if (searchAgent) {
      searchvalue.employeeId = searchAgent
    }
    if (searchBranch) {
      searchvalue.branchId = searchBranch
    }
    if (searchEvent) {
      searchvalue.eventId = searchEvent
    }
    if (searchLeadNo) {
      searchvalue.leadNo = searchLeadNo
    }
    if (searchFromDate) {
      searchvalue.eventFromDate = searchFromDate
    }
    if (searchToDate) {
      searchvalue.eventToDate = searchToDate
    }
    setSearchValue({
      fromDate: searchFromDate,
      toDate: searchToDate,
    })
    specificDispatch(assignedEcAction.loadAssignedEcList(searchvalue))
    setBtnLoading(true)
    setBtnLoader(true)
    setTimeout(() => {
      setBtnLoader(false)
      setBtnLoading(false)
    }, 2000)
  }

  //reset functionalities
  const [resetManager, setResetManager] = useState(false)
  const resetForm = () => {
    setCompanies([])
    setBranches([])
    setSalesAgent([])
    setEvents([])
    setAssignedData({
      fromDate: "",
      toDate: "",
      leadNo: "",
    })
    setSearchValue({
      fromDate: "",
      toDate: "",
    })
    setDownloadLoading(true)
    setTimeout(() => {
      setDownloadLoading(false)
    }, 2000)
    setResetManager(true)
    setTimeout(() => {
      setResetManager(false)
    }, 0)
    dispatch(
      assignedEcAction.loadAssignedEcList({
        isManageEC: false,
        page: 1,
        limit: 50,
      })
    )
  }

  //Unassigned table

  let slNo = 0
  const assignedDataTable = !isEmpty(assigned_details)
    ? assigned_details.data.map((ecAssignedData, index) => {
      slNo = slNo + 1
      const ecProcessStatus =
        !isEmpty(recordsMetaData) &&
        recordsMetaData.processStatusOptions &&
        recordsMetaData.processStatusOptions.length > 0 &&
        recordsMetaData.processStatusOptions.find(
          (_) => _.processStatusId === ecAssignedData.ecProcessStatus
        ) &&
        recordsMetaData.processStatusOptions.find(
          (_) => _.processStatusId === ecAssignedData.ecProcessStatus
        )
      const processStatusName =
        !isEmpty(recordsMetaData) &&
        recordsMetaData.processStatusOptions &&
        recordsMetaData.processStatusOptions.length > 0 &&
        recordsMetaData.processStatusOptions.find(
          (_) => _.processStatusId === ecAssignedData.processStatus
        ) &&
        recordsMetaData.processStatusOptions.find(
          (_) => _.processStatusId === ecAssignedData.processStatus
        )
      const ecClearanceStatus =
        !isEmpty(recordsMetaData) &&
        recordsMetaData.processStatusOptions &&
        recordsMetaData.processStatusOptions.length > 0 &&
        recordsMetaData.processStatusOptions.find(
          (_) =>
            _.processStatusId === ecAssignedData.leadClearance.clearanceStatus
          // _.processStatusId === ecAssignedData.leadClearance.clearanceStatus
        ) &&
        recordsMetaData.processStatusOptions.find(
          (_) =>
            _.processStatusId === ecAssignedData.leadClearance.clearanceStatus
          // _.processStatusId === ecAssignedData.leadClearance.clearanceStatus
        )
      // const checklistDetailsArray =
      //   !isEmpty(ecAssignedData) &&
      //   ecAssignedData.eventChecklistDetail.length > 0
      //     ? ecAssignedData.eventChecklistDetail.map((data) => {
      //         if (
      //           new Date(data.eventDetails.eventDate) >=
      //             new Date(searchValue.fromDate) &&
      //           new Date(data.eventDetails.eventDate) <=
      //             new Date(searchValue.toDate)
      //         ) {
      //           return data
      //         } else if (
      //           isEmpty(searchValue.fromDate) &&
      //           isEmpty(searchValue.toDate)
      //         ) {
      //           return data
      //         }
      //       })
      //     : []
      const checklistDetailsArray =
        !isEmpty(ecAssignedData) &&
          Array.isArray(ecAssignedData.eventChecklistDetail) &&
          ecAssignedData.eventChecklistDetail.length > 0
          ? ecAssignedData.eventChecklistDetail.filter((data) => {
            const eventDate = data?.eventDetails?.eventDate

            if (!eventDate) return false // Skip if eventDate is missing

            const eventDateObj = new Date(eventDate)
            const fromDateObj = new Date(searchValue.fromDate)
            const toDateObj = new Date(searchValue.toDate)

            if (eventDateObj >= fromDateObj && eventDateObj <= toDateObj) {
              return true
            }

            return isEmpty(searchValue.fromDate) && isEmpty(searchValue.toDate)
          })
          : []

      const teamScheduleDetailsArray =
        !isEmpty(ecAssignedData) &&
          Array.isArray(ecAssignedData.eventTeamscheduleDetail) &&
          ecAssignedData.eventTeamscheduleDetail.length > 0
          ? ecAssignedData.eventTeamscheduleDetail
            .filter((data) => {
              const eventDate = data?.eventDetails?.eventDate

              if (!eventDate) return false // Skip if eventDate is missing

              const eventDateObj = new Date(eventDate)
              const fromDateObj = new Date(searchValue.fromDate)
              const toDateObj = new Date(searchValue.toDate)

              if (eventDateObj >= fromDateObj && eventDateObj <= toDateObj) {
                return true
              }

              return isEmpty(searchValue.fromDate) && isEmpty(searchValue.toDate)
            })
          : []

      // const equipmentDetailsArray =
      //   !isEmpty(ecAssignedData) &&
      //     ecAssignedData.equipmentSchedulingDetail.length > 0
      //     ? ecAssignedData.equipmentSchedulingDetail.map((data) => {
      //       if (
      //         new Date(data.eventDetails.eventDate) >=
      //         new Date(searchValue.fromDate) &&
      //         new Date(data.eventDetails.eventDate) <=
      //         new Date(searchValue.toDate)
      //       ) {
      //         return data
      //       } else if (
      //         isEmpty(searchValue.fromDate) &&
      //         isEmpty(searchValue.toDate)
      //       ) {
      //         return data
      //       }
      //     })
      //     : []
      const equipmentDetailsArray =
        !isEmpty(ecAssignedData) &&
          Array.isArray(ecAssignedData.equipmentSchedulingDetail) &&
          ecAssignedData.equipmentSchedulingDetail.length > 0
          ? ecAssignedData.equipmentSchedulingDetail.filter((data) => {
            const eventDate = data?.eventDetails?.eventDate

            if (!eventDate) return false // Skip if eventDate is missing

            const eventDateObj = new Date(eventDate)
            const fromDateObj = new Date(searchValue.fromDate)
            const toDateObj = new Date(searchValue.toDate)

            if (eventDateObj >= fromDateObj && eventDateObj <= toDateObj) {
              return true
            }

            return isEmpty(searchValue.fromDate) && isEmpty(searchValue.toDate)
          })
          : []

      const checklistDetails =
        !isEmpty(checklistDetailsArray) && checklistDetailsArray.length > 0
          ? checklistDetailsArray.filter((data) => data !== undefined)
          : []
      const teamScheduleDetails =
        !isEmpty(teamScheduleDetailsArray) &&
          teamScheduleDetailsArray.length > 0
          ? teamScheduleDetailsArray.filter((data) => data !== undefined)
          : []
      const equipmentScheduleDetails =
        !isEmpty(equipmentDetailsArray) && equipmentDetailsArray.length > 0
          ? equipmentDetailsArray.filter((data) => data !== undefined)
          : []
      // //console.log(checklistDetailsArray, "checklistDetailsArray")
      // //console.log(checklistDetails, "checklistDetails")
      const checklistCount =
        !isEmpty(checklistDetails) && checklistDetails.length > 0
          ? checklistDetails.length
          : 0
      const eventCount =
        !isEmpty(ecAssignedData) && ecAssignedData.events.length > 0
          ? ecAssignedData.events.length
          : 0
      const followupCount =
        !isEmpty(ecAssignedData) && ecAssignedData.ecfollowupDetail.length > 0
          ? ecAssignedData.ecfollowupDetail.length
          : 0
      const teamSchedulingCount =
        !isEmpty(teamScheduleDetails) && teamScheduleDetails.length > 0
          ? teamScheduleDetails.length
          : 0
      const equipmentSchedulingCount =
        !isEmpty(equipmentScheduleDetails) &&
          equipmentScheduleDetails.length > 0
          ? equipmentScheduleDetails.length
          : 0
      const eventLocationDetails =
        !isEmpty(ecAssignedData) && ecAssignedData.events.length > 0
          ? ecAssignedData.events.map((data) => data.venueLocation)
          : []

      const eventLocation =
        !isEmpty(eventLocationDetails) && eventLocationDetails.length > 0
          ? eventLocationDetails.join(",")
          : "--"

      return {
        _id: ecAssignedData._id,
        sNo: slNo,
        routeData: ecAssignedData,
        leadNo: ecAssignedData.leadNo,
        checklistCount: checklistCount,
        checklist: checklistDetails,
        equipmentSchedulingCount: equipmentSchedulingCount,
        followupCount: followupCount,
        teamSchedulingCount: teamSchedulingCount,
        followup: ecAssignedData.ecfollowupDetail,
        equipmentDetails: equipmentScheduleDetails,
        equipmentSchedulingCommitment:
          ecAssignedData.equipmentFinalCommitment,
        teamSchedulingCommitment: ecAssignedData.SchedulingFinalCommitment,
        teamScheduling: teamScheduleDetails,
        clientName: !isEmpty(ecAssignedData.clientDetails)
          ? ecAssignedData.clientDetails.firstName +
          " " +
          ecAssignedData.clientDetails.lastName
          : "",
        brideName: ecAssignedData.brideName,
        branchName: ecAssignedData.branchName,
        groomName: ecAssignedData.groomName,
        eventDetails: ecAssignedData.events,
        clientCode: !isEmpty(ecAssignedData.clientDetails)
          ? ecAssignedData.clientDetails.clientNo
          : "",
        eventCount: eventCount,
        eventLocation: eventLocation,
        ecAgent: !isEmpty(ecAssignedData.leadECAssign)
          ? ecAssignedData.leadECAssign.assignedToName
          : "--",
        events: ecAssignedData.events,
        ecProcessStatus: ecAssignedData.ecProcessStatus,
        ecProcessStatusName: !isEmpty(ecProcessStatus)
          ? ecProcessStatus.label
          : "",
        ecProcessStatusColor: !isEmpty(ecProcessStatus)
          ? ecProcessStatus.colorCode
          : "",
        ecClearanceStatusName: !isEmpty(ecClearanceStatus)
          ? ecClearanceStatus.label
          : "",
        // ecClearanceStatusColor: !isEmpty(ecClearanceStatus)
        //   ? ecClearanceStatus.colorCode
        //   : "",
        paymentType: !isEmpty(assignedData.leadClearance)
          ? assignedData.leadClearance.type
          : "",
        processStatus: assignedData.processStatus,
        processStatusName: !isEmpty(processStatusName)
          ? processStatusName.label
          : "",
        processStatusColor: !isEmpty(processStatusName)
          ? processStatusName.colorCode
          : "",
        key: index,
      }
    })
    : []

  const unAssignedTable = !isEmpty(assignedDataTable)
    ? assignedDataTable.filter((data) => data !== undefined)
    : []

  //pagination table data columns
  // const { ExportCSVButton } = CSVExport

  const columns = [
    {
      dataField: "sNo",
      text: "S.No",
    },
    {
      dataField: "leadNo",
      text: "Lead No",
      // sort: true,
      formatter: (cellContent, row) => {
        const leadData = row.routeData
        return (
          <div>
            {" "}
            <Link
              to={{
                pathname: `/client-details/${row._id}`,
                state: {
                  row: leadData,
                  mode: "EC",
                  prevPathname: location.pathname,
                  menuName: "EcAssigned",
                },
              }}
            >
              <span>{row.leadNo}</span>
            </Link>
          </div>
        )
      },
      style: {
        color: "#e40d8c",
        textTransform: "uppercase",
      },
      csvExport: false,
      headerStyle: {
        minWidth: "120px",
      },
    },
    {
      dataField: "branchName",
      text: "Branch Name",
      // sort: true,
      style: {
        textTransform: "uppercase",
      },
      headerStyle: {
        minWidth: "125px",
      },
    },
    {
      dataField: "clientName",
      text: "Client Name",
      // sort: true,
      style: {
        textTransform: "uppercase",
      },
      headerStyle: {
        minWidth: "155px",
      },
    },
    {
      dataField: "eventCount",
      text: "No.of events",
      formatter: (cellContent, row) => {
        return (
          <div className="space-between">
            <span className="badge rounded-pill bg-primary">
              {row.eventCount}
            </span>
          </div>
        )
      },
      headerStyle: {
        minWidth: "108px",
      },
    },
    {
      dataField: "ecAgent",
      text: "EC Executive",
      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "clearanceStatus",
      text: "Clearance",
      formatter: (cellContent, row) => {
        return (
          <>
            {row.ecClearanceStatusName ? (
              <button
                style={{
                  background:
                    row.paymentType == "paid"
                      ? "#34c28f"
                      : row.paymentType == "partialPaid" ||
                        row.paymentType === "partialpaid"
                        ? "#f1734f"
                        : "#c31919ed",
                  border: "none",
                  cursor: "pointer",
                  color: "white",
                  padding: "4px 6px",
                  borderRadius: "4px",
                }}
              >
                {row.ecClearanceStatusName}
              </button>
            ) : (
              "--"
            )}
          </>
        )
      },

      headerStyle: {
        minWidth: "192px",
      },
    },
    {
      dataField: "ecStatus",
      text: "Ec Status",
      formatter: (cellContent, row) => {
        return (
          <>
            {row.ecProcessStatusName ? (
              <button
                style={{
                  background: row.ecProcessStatusColor,
                  border: "none",
                  cursor: "pointer",
                  color: "white",
                  padding: "4px 6px",
                  borderRadius: "4px",
                }}
              >
                {row.ecProcessStatusName}
              </button>
            ) : (
              "--"
            )}
          </>
        )
      },
      headerStyle: {
        minWidth: "192px",
      },
    },
    {
      dataField: "checklistCount",
      text: "Checklist",
      // sort: true,
      formatter: (cellContent, row) => {
        return (
          <div
            onClick={() => {
              setChecklistModal(true)
              setChecklistDetails(row.checklist)
            }}
            style={{
              color: "#e40d8c",
              fontSize: "14px",
              textDecoration: "underline",
            }}
          >
            {row.checklistCount}
          </div>
        )
      },
      headerStyle: {
        minWidth: "100px",
      },
    },
    {
      dataField: "followupCount",
      text: "Followups",
      // sort: true,
      formatter: (cellContent, row) => {
        return (
          <div
            onClick={() => {
              setFollowupModal(true)
              setFollowupDetails(row.followup)
            }}
            style={{
              color: "#e40d8c",
              fontSize: "14px",
              textDecoration: "underline",
            }}
          >
            {row.followupCount}
          </div>
        )
      },
      headerStyle: {
        minWidth: "100px",
      },
    },
    {
      dataField: "teamSchedulingCount",
      text: "Team Scheduling",
      // sort: true,
      formatter: (cellContent, row) => {
        return (
          <div
            onClick={() => {
              setTeamModal(true)
              setTeamDetails(row.teamScheduling)
            }}
            style={{
              color: "#e40d8c",
              fontSize: "14px",
              textDecoration: "underline",
            }}
          >
            {row.teamSchedulingCount}
          </div>
        )
      },
      headerStyle: {
        minWidth: "142px",
      },
    },
    {
      dataField: "teamSchedulingCommitment",
      text: "TS Final Commitment",
      // sort: true,
      formatter: (cellContent, row) => {
        return (
          <>
            {!isEmpty(row.teamSchedulingCommitment) ? (
              <Badge
                color={
                  row.teamSchedulingCommitment === "Yes" ? "success" : "danger"
                }
                style={{ padding: "6px", fontSize: "12px" }}
              >
                {row.teamSchedulingCommitment}
              </Badge>
            ) : (
              "--"
            )}
          </>
        )
      },
      headerStyle: {
        minWidth: "170px",
      },
    },
    {
      dataField: "equipmentSchedulingCount",
      text: "Equipment Scheduling",
      formatter: (cellContent, row) => {
        const equipmentScheduling =
          !isEmpty(row.equipmentDetails) && row.equipmentDetails.length > 0
            ? row.equipmentDetails
            : []
        return (
          <div
            onClick={() => {
              setEquipmentModal(true)
              setEquipmentDetails(equipmentScheduling)
            }}
            style={{
              color: "#e40d8c",
              fontSize: "14px",
              textDecoration: "underline",
            }}
          >
            {row.equipmentSchedulingCount}
          </div>
        )
      },
      headerStyle: {
        minWidth: "180px",
      },
    },
    {
      dataField: "equipmentSchedulingCommitment",
      text: "ES Final Commitment",
      // sort: true,
      formatter: (cellContent, row) => {
        return (
          <>
            {!isEmpty(row.equipmentSchedulingCommitment) ? (
              <Badge
                color={
                  row.equipmentSchedulingCommitment === "Yes"
                    ? "success"
                    : "danger"
                }
                style={{ padding: "6px", fontSize: "12px" }}
              >
                {row.equipmentSchedulingCommitment}
              </Badge>
            ) : (
              "--"
            )}
          </>
        )
      },
      headerStyle: {
        minWidth: "170px",
      },
    },
    {
      dataField: "leadStatus",
      text: "Lead Status",
      // sort: true,
      formatter: (cellContent, row) => {
        return (
          <>
            {row.processStatusName ? (
              <button
                style={{
                  background: row.processStatusColor,
                  border: "none",
                  cursor: "pointer",
                  color: "white",
                  padding: "4px 6px",
                  borderRadius: "4px",
                }}
              >
                {row.processStatusName}
              </button>
            ) : (
              "--"
            )}
          </>
        )
      },
      headerStyle: {
        minWidth: "192px",
      },
    },
  ]

  // const searchValue = !isEmpty(searchValueList)
  //   ? searchValueList
  //   : {
  //       isManageEC: false,
  //       page: pageChange ? pageCount : 1,
  //       limit: 50,
  //     }

  //Pagination section start //
  //Search filter
  const [searchFilter, setSearchFilter] = useState(false)
  // //console.log(searchInput, "searchInput")

  const handleClick = (e) => {
    // props.onSearch(input.value)
    // //console.log(input.value, "inputs")
    e.preventDefault()
    setSearchFilter(true)
    specificDispatch(
      assignedEcAction.loadAssignedEcList({
        searchFilter: searchInput,
        isManageEC: false,
        page: pageChange ? pageCount : 1,
        limit: 50,
      })
    )
    setTimeout(() => {
      setSearchFilter(false)
    }, 1200)
  }

  const downloadFile = ({ data, fileName, fileType }) => {
    const blob = new Blob([data], { type: fileType })

    const a = document.createElement("a")
    a.download = fileName
    a.href = window.URL.createObjectURL(blob)
    const clickEvt = new MouseEvent("click", {
      view: window,
      bubbles: true,
      cancelable: true,
    })
    a.dispatchEvent(clickEvt)
    a.remove()
  }
  const exportToCsv = () => {

    var searchCompany = companies && companies ? company : ""
    var searchBranch = branches && branches ? branch : ""
    var searchEvent = events && events ? events.value : ""
    var searchAgent = salesAgent && salesAgent ? salesAgent.value : ""

    var searchFromDate =
      assignedData && assignedData.fromDate
        ? moment(assignedData.fromDate).format("YYYY-MM-DD")
        : ""
    var searchToDate =
      assignedData && assignedData.toDate
        ? moment(assignedData.toDate).format("YYYY-MM-DD")
        : ""
    var searchLeadNo =
      assignedData && assignedData.leadNo ? assignedData.leadNo : ""

    var searchvalue = {}

    if (searchCompany) {
      searchvalue.companyId = searchCompany
    }
    if (searchAgent) {
      searchvalue.employeeId = searchAgent
    }
    if (searchBranch) {
      searchvalue.branchId = searchBranch
    }
    if (searchEvent) {
      searchvalue.eventId = searchEvent
    }
    if (searchLeadNo) {
      searchvalue.leadNo = searchLeadNo
    }
    if (searchFromDate) {
      searchvalue.eventFromDate = searchFromDate
    }
    if (searchToDate) {
      searchvalue.eventToDate = searchToDate
    }
    setPageLoad(!pageLoad)

    setDownloadLoading(true)
    api
      .post(`/lead_ec_assign_details_excel_export`, searchvalue)
      .then((response) => {
        //console.log(response.data, "response")
        const unassignedExcelDataTable = !isEmpty(response.data.data)
          ? response.data.data.map((assignedData, index) => {
            // if (isEmpty(assignedData.ecPrcessStatusName)) {
            // slNo = slNo + 1

            const ecClearanceStatus =
              !isEmpty(recordsMetaData) &&
              recordsMetaData.processStatusOptions &&
              recordsMetaData.processStatusOptions.length > 0 &&
              recordsMetaData.processStatusOptions.find(
                (_) => _.processStatusId === assignedData.ecProcessStatus
              ) &&
              recordsMetaData.processStatusOptions.find(
                (_) => _.processStatusId === assignedData.ecProcessStatus
              )
            const processStatusName =
              !isEmpty(recordsMetaData) &&
              recordsMetaData.processStatusOptions &&
              recordsMetaData.processStatusOptions.length > 0 &&
              recordsMetaData.processStatusOptions.find(
                (_) => _.processStatusId === assignedData.processStatus
              ) &&
              recordsMetaData.processStatusOptions.find(
                (_) => _.processStatusId === assignedData.processStatus
              )
            const checklistCount =
              !isEmpty(assignedData) &&
                assignedData.eventChecklistDetail.length > 0
                ? assignedData.eventChecklistDetail.length
                : 0
            const eventCount =
              !isEmpty(assignedData) && assignedData.events.length > 0
                ? assignedData.events.length
                : 0
            const followupCount =
              !isEmpty(assignedData) &&
                assignedData.ecfollowupDetail.length > 0
                ? assignedData.ecfollowupDetail.length
                : 0
            const teamSchedulingCount =
              !isEmpty(assignedData) &&
                assignedData.eventTeamscheduleDetail.length > 0
                ? assignedData.eventTeamscheduleDetail.length
                : 0
            const equipmentSchedulingCount =
              !isEmpty(assignedData) &&
                assignedData.equipmentSchedulingDetail.length > 0
                ? assignedData.equipmentSchedulingDetail.length
                : 0
            const eventLocationDetails =
              !isEmpty(assignedData) && assignedData.events.length > 0
                ? assignedData.events.map((data) => data.venueLocation)
                : []

            const eventLocationDataDetails =
              !isEmpty(eventLocationDetails) &&
                eventLocationDetails.length > 0
                ? eventLocationDetails.join(",")
                : ""
            const eventLocation = !isEmpty(eventLocationDataDetails)
              ? JSON.stringify(eventLocationDataDetails).replace(/","/g, "\n")
              : "--"
            //console.log(
            //   assignedData.equipmentSchedulingDetail,
            //   "equipmentSchedulingDetail"
            // )
            return {
              _id: assignedData._id,
              sNo: index + 1,
              routeData: assignedData,
              leadNo: assignedData.leadNo,
              checklistCount: checklistCount,
              checklist: assignedData.eventChecklistDetail,
              equipmentSchedulingCount: equipmentSchedulingCount,
              followupCount: followupCount,
              teamSchedulingCount: teamSchedulingCount,
              followup: assignedData.ecfollowupDetail,
              equipmentDetails: assignedData.equipmentSchedulingDetail,
              equipmentSchedulingCommitment:
                assignedData.equipmentFinalCommitment,
              teamSchedulingCommitment:
                assignedData.SchedulingFinalCommitment,
              teamScheduling: assignedData.eventTeamscheduleDetail,
              clientName: !isEmpty(assignedData.clientDetails)
                ? assignedData.clientDetails.firstName +
                " " +
                assignedData.clientDetails.lastName
                : "",
              brideName: assignedData.brideName,
              groomName: assignedData.groomName,
              eventDetails: assignedData.events,
              clientCode: !isEmpty(assignedData.clientDetails)
                ? assignedData.clientDetails.clientNo
                : "",
              eventCount: eventCount,
              eventLocation: eventLocation,
              ecAgent: !isEmpty(assignedData.leadECAssign)
                ? assignedData.leadECAssign.assignedToName
                : "--",
              events: assignedData.events,
              ecProcessStatus: assignedData.ecProcessStatus,
              ecProcessStatusName: !isEmpty(ecClearanceStatus)
                ? ecClearanceStatus.label
                : "--",
              ecProcessStatusColor: !isEmpty(ecClearanceStatus)
                ? ecClearanceStatus.colorCode
                : "",
              processStatus: assignedData.processStatus,
              processStatusName: !isEmpty(processStatusName)
                ? processStatusName.label
                : "--",
              processStatusColor: !isEmpty(processStatusName)
                ? processStatusName.colorCode
                : "",
              key: index,
            }
          })
          : []
        setTimeout(() => {
          let headerData = [
            "SNo, Lead No , Client Name ,No.of events,Event Location, EC Executive,Clearance, Checklist, Followups,Team Scheduling,Team Scheduling Final Commitment,Equipment Scheduling,Equipment Scheduling Final Commitment,Lead Status",
          ]

          let usersCsv =
            !isEmpty(unassignedExcelDataTable) &&
            unassignedExcelDataTable.reduce((acc, user) => {
              const {
                sNo,
                leadNo,
                clientName,
                eventCount,
                eventLocation,
                ecAgent,
                ecProcessStatusName,
                checklistCount,
                followupCount,
                teamSchedulingCount,
                teamSchedulingCommitment,
                equipmentSchedulingCount,
                equipmentSchedulingCommitment,
                processStatusName,
              } = user
              acc.push([
                sNo,
                leadNo,
                clientName,
                eventCount,
                eventLocation,
                ecAgent,
                ecProcessStatusName,
                checklistCount,
                followupCount,
                teamSchedulingCount,
                teamSchedulingCommitment,
                equipmentSchedulingCount,
                equipmentSchedulingCommitment,
                processStatusName,
              ])

              //console.log("test", acc)
              return acc
            }, [])
          //console.log(usersCsv, "usersCsv")
          const userList =
            !isEmpty(usersCsv) && usersCsv.length > 0 ? usersCsv : ""
          downloadFile({
            data: [...headerData, ...userList].join("\n"),
            fileName: "AssignedEc.csv",
            fileType: "text/csv",
          })
          setDownloadLoading(false)
        }, 2500)

        return response.data
      })
      .catch((error) => Promise.reject(error))

  }
  const RemotePagination = ({
    data,
    page,
    // sort,
    sizePerPage,
    onTableChange,
    totalSize,
  }) => (
    <div>
      <PaginationProvider
        pagination={paginationFactory({
          custom: true,
          page,
          // sort,
          sizePerPage,
          totalSize,
        })}
      >
        {({ paginationProps, paginationTableProps }) => (
          <div>
            <ToolkitProvider
              keyField="_id"
              data={data}
              columns={columns}
              search
              exportCSV
            >
              {() => (
                <div>
                  <Col md="12" xl="12" lg="12" sm="12" xs="12">
                    <Row className="d-flex flex-row">
                      <Col className="mb-3" md="4">
                        {/* <div className="d-flex flex-row ">
                          <div className="search-box me-2 mb-2 d-inline-block d-flex flex-row ">
                            <div
                              className="position-relative mt-7"
                              style={searchBarStyle || null}
                            >
                              <MySearch {...props.searchProps} />
                              <i className="bx bx-search-alt search-icon" />
                            </div>
                          </div>
                        </div>{" "} */}
                      </Col>

                      <Col md="8">
                        <div
                          style={{
                            float: "right",
                          }}
                        >
                          <Button
                            className="btn btn-primary"
                            onClick={exportToCsv}
                            id="download"
                            style={{
                              backgroundColor: "#e40d8c",
                              color: "white",
                              border: "none",
                              marginBottom: "20px",
                              marginTop: "-41px",
                            }}
                          >
                            Download
                          </Button>
                        </div>
                      </Col>

                      <Col>
                        <BootstrapTable
                          remote
                          // {...props.baseProps}
                          keyField="_id"
                          data={data}
                          id="ImportTable"
                          columns={columns}
                          responsive
                          striped={true}
                          bordered={true}
                          onTableChange={onTableChange}
                          {...paginationTableProps}
                          expandRow={expandRow}
                          headerClasses="headerFixed"

                        // sort={ sortOption}
                        />
                      </Col>
                    </Row>
                    <Row
                      style={{ marginTop: "5px" }}
                      className="align-items-md-center mt-30"
                    >
                      <Col className="inner-custom-pagination d-flex">
                        <div className="d-inline d-flex flex-row">
                          <SizePerPageDropdownStandalone {...paginationProps} />
                          <div
                            style={{
                              fontSize: "14px",
                              marginTop: "8px",
                              marginLeft: "4px",
                            }}
                          >
                            <PaginationTotalStandalone {...paginationProps} />
                          </div>
                        </div>
                        <div
                          className="text-md-right ms-auto"
                          style={{ zIndex: 0 }}
                        >
                          <PaginationListStandalone
                            // paginationTotalRenderer={leave_list.totalDataCount}
                            {...paginationProps}
                          />
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </div>
              )}
            </ToolkitProvider>
          </div>
        )}
      </PaginationProvider>
    </div>
  )
  // const [pageLoad, setPageLoad] = useState(false)
  const [state, setState] = useState({
    sizePerPage: 50,
    page: 1,
    totalSize: assigned_details.length,
    data:
      !isEmpty(assigned_details) && assigned_details.length > 0
        ? assigned_details.slice(0, 50)
        : [],
  })
  const { sizePerPage, page } = state

  //Table Change

  const handleTableChange = (type, { page, currentIndex, sizePerPage }) => {
    setPageCount(page)
    setPageChange(true)
    setPageLoad(!pageLoad)
    //console.log(page, "page")
    let result =
      !isEmpty(assigned_details.data) && assigned_details.data.length > 0
        ? assigned_details.data
        : []
    if (
      !isEmpty(companies) ||
      !isEmpty(branches) ||
      !isEmpty(events) ||
      !isEmpty(salesAgent) ||
      !isEmpty(assignedData.fromDate) ||
      !isEmpty(assignedData.toDate)
    ) {
      var searchCompany = companies && companies ? company : ""
      var searchBranch = branches && branches ? branch : ""
      var searchEvent = events && events ? events.value : ""
      var searchAgent = salesAgent && salesAgent ? salesAgent.value : ""
      // var searchPaymentStatus =
      //   paymentStatus && paymentStatus ? paymentStatus.value : ""
      var searchFromDate =
        assignedData && assignedData.fromDate
          ? moment(assignedData.fromDate).format("YYYY-MM-DD")
          : ""
      var searchToDate =
        assignedData && assignedData.toDate
          ? moment(assignedData.toDate).format("YYYY-MM-DD")
          : ""
      var searchLeadNo =
        assignedData && assignedData.leadNo ? assignedData.leadNo : ""

      var searchvalue = {}
      searchvalue.page = pageChange ? pageCount : 1
      searchvalue.limit = sizePerPage
      searchvalue.isManageEC = false
      if (searchCompany) {
        searchvalue.companyId = searchCompany
      }
      if (searchAgent) {
        searchvalue.employeeId = searchAgent
      }
      if (searchBranch) {
        searchvalue.branchId = searchBranch
      }
      if (searchEvent) {
        searchvalue.eventId = searchEvent
      }
      if (searchLeadNo) {
        searchvalue.leadNo = searchLeadNo
      }
      if (searchFromDate) {
        searchvalue.eventFromDate = searchFromDate
      }
      if (searchToDate) {
        searchvalue.eventToDate = searchToDate
      }
      setDownloadLoading(true)
      specificDispatch(assignedEcAction.loadAssignedEcList(searchvalue))
    } else {
      specificDispatch(
        assignedEcAction.loadAssignedEcList({
          page: page,
          limit: sizePerPage,
          isManageEC: false,
        })
      )
      setDownloadLoading(true)
      setPageLoad(!pageLoad)
    }
    // setPageCount(page)
    // setTimeout(() => {
    //   setLoading(false)
    // }, 2000)
    setTimeout(() => {
      setDownloadLoading(false)
    }, 2000)

    setState(() => ({
      page,
      data: result.slice(currentIndex, currentIndex + sizePerPage),
      totalSize: result.length,
      sizePerPage,
    }))
  }

  //Pagination section end //

  ////console.log(row.events,"r")
  const expandRow = {
    renderer: (row) => (
      <>
        <Table bordered>
          <thead>
            <tr>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Event No
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Event Name
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Event Date
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Time
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Location
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Venue Name
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Crowd Strength
              </th>
            </tr>
          </thead>
          <tbody>
            {row && row.eventDetails.length > 0 ? (
              row.eventDetails.map((data) => {
                //console.log(data, "row list data")

                const dateFormate =
                  !isEmpty(dateSetting) && dateSetting ? dateSetting : ""

                //console.log(dateFormate, "dateFormate")
                // const eventFromDate = moment(data.eventDate).format(
                //   "YYYY-MM-DD"
                // )
                //console.log(eventFromDate, "eventFrom Date")
                // const eventDate = new Date(data.eventDate)
                //console.log(eventDate, "eventDate")
                if (
                  new Date(data.eventDate) >= new Date(assignedData.fromDate) &&
                  new Date(data.eventDate) <= new Date(assignedData.toDate)
                ) {
                  //console.log(data, "expandRow data")
                  return (
                    <tr key={data._id}>
                      <th scope="data">{data.eventNo}</th>
                      <td>{data.eventName}</td>
                      <td>
                        {!isEmpty(data.eventDate)
                          ? moment(data.eventDate).format(dateFormate)
                          : "--"}
                      </td>
                      <th>{data.crewAssemblyTime}</th>
                      <td>{data.venueLocation}</td>
                      <td>{data.venueName}</td>
                      <td>{data.crowdStrength}</td>
                    </tr>
                  )
                } else if (
                  isEmpty(assignedData.fromDate) &&
                  isEmpty(assignedData.toDate)
                ) {
                  return (
                    <tr key={data._id}>
                      <th scope="data">{data.eventNo}</th>
                      <td>{data.eventName}</td>
                      <td>
                        {!isEmpty(data.eventDate)
                          ? moment(data.eventDate).format(dateFormate)
                          : "--"}
                      </td>
                      <th>{data.crewAssemblyTime}</th>
                      <td>{data.venueLocation}</td>
                      <td>{data.venueName}</td>
                      <td>{data.crowdStrength}</td>
                    </tr>
                  )
                }
              })
            ) : (
              <tr key={0}>
                <td className="text-align-center" colSpan={7}>
                  No data found
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </>
    ),
    showExpandColumn: true,
    expandByColumnOnly: true,
    onlyOneExpanding: true,
  }

  // const options = {
  //   sizePerPage: 50,
  //   totalSize: unAssignedTable.length, // replace later with size(customers),
  //   custom: true,
  //   pageStartIndex: 1,
  //   firstPageText: "First",
  //   nextPageText: "Next",
  //   lastPageText: "Last",
  //   nextPageTitle: "First page",
  //   firstPageTitle: "Next page",
  //   lastPageTitle: "Last page",
  //   showTotal: true,
  // }

  //Checklist columns and modal

  const checklistDataTable =
    !isEmpty(checklistDetails) && checklistDetails.length > 0
      ? checklistDetails.map((data, index) => {
        const questionsCount =
          !isEmpty(data) && data.ChecklistDetail.length > 0
            ? data.ChecklistDetail.length
            : 0
        const eventDate =
          !isEmpty(data.eventDetails) && data.eventDetails.eventDate
            ? moment(data.eventDetails.eventDate).format("DD-MM-YYYY")
            : "--"
        return {
          sNo: index + 1,
          _id: data._id,
          checklistDetail: data.ChecklistDetail,
          eventName: !isEmpty(data.eventDetails)
            ? data.eventDetails.eventName
            : "--",
          eventNo: !isEmpty(data.eventDetails)
            ? data.eventDetails.eventNo
            : "--",
          startTime: !isEmpty(data.eventDetails)
            ? data.eventDetails.startTime
            : "--",
          endTime: !isEmpty(data.eventDetails)
            ? data.eventDetails.endTime
            : "--",
          venueLocation: !isEmpty(data.eventDetails)
            ? data.eventDetails.venueLocation
            : "--",
          eventDate: eventDate,
          questionsCount: questionsCount,
          key: index,
        }
      })
      : []
  const checklistColumns = [
    {
      dataField: "sNo",
      text: "S.No",
    },
    {
      dataField: "questionsCount",
      text: "Questions",
      formatter: (cellContent, row) => {
        return (
          <div
            className="space-between"
          // onClick={() => setEventDetails(data.events)}
          >
            <span className="badge rounded-pill bg-primary">
              {row.questionsCount}
            </span>
          </div>
        )
      },
    },
    {
      dataField: "eventName",
      text: "Event Name",
      headerStyle: {
        minWidth: "140px",
      },
    },
    {
      dataField: "eventNo",
      text: "Event No",
      headerStyle: {
        minWidth: "140px",
      },
    },
    {
      dataField: "eventDate",
      text: "Event Date",
      headerStyle: {
        minWidth: "140px",
      },
    },
    {
      dataField: "startTime",
      text: "Start Time",
      headerStyle: {
        minWidth: "140px",
      },
    },
    {
      dataField: "endTime",
      text: "End Time",
      headerStyle: {
        minWidth: "140px",
      },
    },
    {
      dataField: "venueLocation",
      text: "Venue Location",
      headerStyle: {
        minWidth: "140px",
      },
    },
  ]

  const checklistExpandRow = {
    renderer: (row) => (
      <>
        <Table bordered>
          <thead>
            <tr>
              {/* <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                S.No
              </th> */}
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Question
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Answer
              </th>
            </tr>
          </thead>
          <tbody>
            {row && row.checklistDetail.length > 0 ? (
              row.checklistDetail.map((data, index) => {
                //console.log(data, "row list data")

                return (
                  <tr key={index}>
                    {/* <th scope="data">{index + 1}</th> */}
                    <td>{data.checkListQuestion}</td>
                    <td>{data.answer}</td>
                  </tr>
                )
              })
            ) : (
              <tr key={0}>
                <td className="text-align-center" colSpan={7}>
                  No data found
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </>
    ),
    showExpandColumn: true,
    expandByColumnOnly: true,
    onlyOneExpanding: true,
  }

  //Team scheduling columns and modal

  const teamScheduleDataTable =
    !isEmpty(teamDetails) && teamDetails.length > 0
      ? teamDetails.map((data, index) => {
        const serviceCount =
          !isEmpty(data) && data.serviceDetails.length > 0
            ? data.serviceDetails.length
            : 0
        const eventDate =
          !isEmpty(data.eventDetails) && data.eventDetails.eventDate
            ? moment(data.eventDetails.eventDate).format("DD-MM-YYYY")
            : "--"
        return {
          sNo: index + 1,
          _id: data._id,
          serviceDetails: data.serviceDetails,
          serviceCount: serviceCount,
          eventName: !isEmpty(data.eventDetails)
            ? data.eventDetails.eventName
            : "--",
          eventNo: !isEmpty(data.eventDetails)
            ? data.eventDetails.eventNo
            : "--",
          startTime: !isEmpty(data.eventDetails)
            ? data.eventDetails.startTime
            : "--",
          endTime: !isEmpty(data.eventDetails)
            ? data.eventDetails.endTime
            : "--",
          venueLocation: !isEmpty(data.eventDetails)
            ? data.eventDetails.venueLocation
            : "--",
          eventDate: eventDate,
          isCommit: data.isCommit,
          key: index,
        }
      })
      : []
  const teamScheduleColumns = [
    {
      dataField: "sNo",
      text: "S.No",
    },
    {
      dataField: "serviceCount",
      text: "Services",
      formatter: (cellContent, row) => {
        return (
          <div className="space-between">
            <span className="badge rounded-pill bg-primary">
              {row.serviceCount}
            </span>
          </div>
        )
      },
    },
    {
      dataField: "isCommit",
      text: "Commit",
      headerStyle: {
        minWidth: "140px",
      },
      formatter: (cellContent, row) => {
        return (
          <Badge
            color={row.isCommit === true ? "success" : "danger"}
            style={{ padding: "6px", fontSize: "12px" }}
          >
            {row.isCommit === true ? "Yes" : "No"}
          </Badge>
        )
      },
    },
    {
      dataField: "eventName",
      text: "Event Name",
      headerStyle: {
        minWidth: "140px",
      },
    },
    {
      dataField: "eventNo",
      text: "Event No",
      headerStyle: {
        minWidth: "140px",
      },
    },
    {
      dataField: "eventDate",
      text: "Event Date",
      headerStyle: {
        minWidth: "140px",
      },
    },
    {
      dataField: "startTime",
      text: "Start Time",
      headerStyle: {
        minWidth: "140px",
      },
    },
    {
      dataField: "endTime",
      text: "End Time",
      headerStyle: {
        minWidth: "140px",
      },
    },
    {
      dataField: "venueLocation",
      text: "Venue Location",
      headerStyle: {
        minWidth: "140px",
      },
    },
  ]

  const teamScheduleExpandRow = {
    renderer: (row) => (
      <>
        <Table bordered>
          <thead>
            <tr>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Service No
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Service Name
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Payment Status
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Team Shooter
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Freelancer Name
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Freelancer Amount
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Sub Freelancer Name
              </th>
            </tr>
          </thead>
          <tbody>
            {row && row.serviceDetails.length > 0 ? (
              row.serviceDetails.map((data, index) => {
                //console.log(data, "row list data")
                const freelancer =
                  !isEmpty(data) && data.teamFreelanceShooter.length > 0
                    ? data.teamFreelanceShooter.map(
                      (data) => data.freelanceMainShooterName
                    )
                    : []
                const freelancerName =
                  !isEmpty(freelancer) && freelancer.length > 0
                    ? freelancer.join(",")
                    : "--"
                const freelanceSubShooter =
                  !isEmpty(data) && data.teamFreelanceShooter.length > 0
                    ? data.teamFreelanceShooter.map(
                      (data) => data.freelanceSubShooterName
                    )
                    : []
                const freelanceSubShooterName =
                  !isEmpty(freelanceSubShooter) &&
                    freelanceSubShooter.length > 0
                    ? freelanceSubShooter.join(",")
                    : "--"
                const amountData =
                  !isEmpty(data) && data.teamFreelanceShooter.length > 0
                    ? data.teamFreelanceShooter.map((data) => data.amount)
                    : []
                const amount =
                  !isEmpty(amountData) && amountData.length > 0
                    ? amountData.join(",")
                    : "--"
                return (
                  <tr key={index}>
                    <td>{data.serviceNo}</td>
                    <td>{data.serviceName}</td>
                    <td>{data.paymentStatus}</td>
                    <td>
                      {!isEmpty(data.teamEmployeeShooterName)
                        ? data.teamEmployeeShooterName
                        : "--"}
                    </td>
                    <td>{freelancerName}</td>
                    <td>{amount}</td>
                    <td>{freelanceSubShooterName}</td>
                  </tr>
                )
              })
            ) : (
              <tr key={0}>
                <td className="text-align-center" colSpan={7}>
                  No data found
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </>
    ),
    showExpandColumn: true,
    expandByColumnOnly: true,
    onlyOneExpanding: true,
  }

  //Equipment scheduling columns and modal

  const equipmentScheduleDataTable =
    !isEmpty(equipmentDetails) && equipmentDetails.length > 0
      ? equipmentDetails.map((data, index) => {
        const equipmentCount =
          !isEmpty(data) && data.equipmentDetails.length > 0
            ? data.equipmentDetails.length
            : 0
        const eventDate = !isEmpty(data.eventdate)
          ? moment(data.eventdate).format("DD-MM-YYYY")
          : "--"
        return {
          sNo: index + 1,
          _id: data._id,
          equipmentDetails: data.equipmentDetails,
          equipmentCount: equipmentCount,
          isCommit: data.isCommit,
          eventName: !isEmpty(data.eventDetails)
            ? data.eventDetails.eventName
            : "--",
          eventNo: !isEmpty(data.eventDetails)
            ? data.eventDetails.eventNo
            : "--",
          startTime: !isEmpty(data.eventDetails)
            ? data.eventDetails.startTime
            : "--",
          endTime: !isEmpty(data.eventDetails)
            ? data.eventDetails.endTime
            : "--",
          venueLocation: !isEmpty(data.eventDetails)
            ? data.eventDetails.venueLocation
            : "--",
          eventDate: eventDate,
          key: index,
        }
      })
      : []
  const equipmentScheduleColumns = [
    {
      dataField: "sNo",
      text: "S.No",
    },
    {
      dataField: "equipmentCount",
      text: "Equipments",
      formatter: (cellContent, row) => {
        return (
          <div className="space-between">
            <span className="badge rounded-pill bg-primary">
              {row.equipmentCount}
            </span>
          </div>
        )
      },
    },
    {
      dataField: "isCommit",
      text: "Commit",
      headerStyle: {
        minWidth: "140px",
      },
      formatter: (cellContent, row) => {
        return (
          <Badge
            color={row.isCommit === true ? "success" : "danger"}
            style={{ padding: "6px", fontSize: "12px" }}
          >
            {row.isCommit === true ? "Yes" : "No"}
          </Badge>
        )
      },
    },
    {
      dataField: "eventName",
      text: "Event Name",
      headerStyle: {
        minWidth: "140px",
      },
    },
    {
      dataField: "eventNo",
      text: "Event No",
      headerStyle: {
        minWidth: "140px",
      },
    },
    {
      dataField: "eventDate",
      text: "Event Date",
      headerStyle: {
        minWidth: "140px",
      },
    },
    {
      dataField: "startTime",
      text: "Start Time",
      headerStyle: {
        minWidth: "140px",
      },
    },
    {
      dataField: "endTime",
      text: "End Time",
      headerStyle: {
        minWidth: "140px",
      },
    },
    {
      dataField: "venueLocation",
      text: "Venue Location",
      headerStyle: {
        minWidth: "140px",
      },
    },
  ]

  const equipmentScheduleExpandRow = {
    renderer: (row) => (
      <>
        <Table bordered>
          <thead>
            <tr>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                S.No
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Type
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Equipment Type
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Service Name
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Quantity
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Total Cost
              </th>
            </tr>
          </thead>
          <tbody>
            {row && row.equipmentDetails.length > 0 ? (
              row.equipmentDetails.map((data, index) => {
                //console.log(data, "row list data")
                return (
                  <tr key={index}>
                    <th scope="data">{index + 1}</th>
                    <td>{data.type}</td>
                    <td>{data.equipmentType}</td>
                    <td>{data.serviceName}</td>
                    <td>{data.qty}</td>
                    <td>{data.total}</td>
                  </tr>
                )
              })
            ) : (
              <tr key={0}>
                <td className="text-align-center" colSpan={7}>
                  No data found
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </>
    ),
    showExpandColumn: true,
    expandByColumnOnly: true,
    onlyOneExpanding: true,
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{title} | Zero Gravity CRM</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title={"Reports"} breadcrumbItem={title} />
          <Row>
            <Col xs={12}>
              <Card>
                <CardBody>
                  <form>
                    <Row>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"} htmlFor={"Company"}>
                            {"Company"}
                          </Label>
                        </div>

                        <Select
                          type="text"
                          name="companies"
                          isMulti
                          value={companies}
                          onChange={(e) => handleCompanies(e)}
                          options={
                            recordsMetaData
                              ? recordsMetaData.companyOptions
                              : []
                          }
                          placeholder="Select Company"
                          classNamePrefix="select2-selection"
                          zIndex="2"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"} htmlFor={"Branch"}>
                            {"Branch"}
                          </Label>
                        </div>
                        <Select
                          type="text"
                          name="branches"
                          isMulti
                          value={branches}
                          onChange={(e) => setBranches(e)}
                          options={branchOptions}
                          placeholder="Select Branch"
                          classNamePrefix="select2-selection"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"}>{"Event"}</Label>
                        </div>
                        <Select
                          type="text"
                          name="events"
                          value={events}
                          // isMulti
                          onChange={(e) => setEvents(e)}
                          options={
                            recordsMetaData ? recordsMetaData.eventOptions : []
                          }
                          placeholder="Select event"
                          classNamePrefix="select2-selection"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"}>{"EC Agent"}</Label>
                        </div>
                        <ReactSearchAutocomplete
                          name="salesAgent"
                          key={resetManager}
                          items={agentOptions}
                          value={salesAgent}
                          type="autoComplete"
                          resultStringKeyName="label"
                          showIcon={false}
                          onSelect={(e) => setSalesAgent(e)}
                          onChange={(e) => setSalesAgent(e.target.value)}
                          placeholder="Enter EC Executive"
                          fuseOptions={fuseOptions} // Search on both fields
                          styling={{
                            height: "34px",
                            border: "1px solid #ced4da",
                            borderRadius: "4px",
                            backgroundColor: "white",
                            boxShadow: "none",
                            hoverBackgroundColor: "#E40D8C",
                            color: "black",
                            fontSize: "12px",
                            fontFamily: "Courier",
                            iconColor: "green",
                            clearIconMargin: "3px 8px 0 0",
                            zIndex: 10,
                          }}
                        />
                      </Col>

                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label
                            className="form-label"
                            htmlFor={"Event From Date"}
                          >
                            {"Event From Date"}
                          </Label>
                        </div>
                        <Input
                          type="date"
                          placeholder="Select Date"
                          name="fromDate"
                          value={assignedData.fromDate}
                          max={assignedData.toDate}
                          onChange={(e) => handleChange(e)}
                        />
                      </Col>

                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label
                            className="form-label"
                            htmlFor={"Event To Date"}
                          >
                            {"Event To Date"}
                          </Label>
                        </div>
                        <Input
                          type="date"
                          placeholder="Select Date"
                          name="toDate"
                          value={assignedData.toDate}
                          min={assignedData.fromDate}
                          onChange={(e) => handleChange(e)}
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label
                            className="form-label"
                            htmlFor={"Event To Date"}
                          >
                            {"Lead No"}
                          </Label>
                        </div>
                        <Input
                          type="text"
                          placeholder="Enter Lead No"
                          name="leadNo"
                          value={assignedData.leadNo}
                          // min={assignedData.fromDate}
                          onChange={(e) => handleChange(e)}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col lg="12" md="12" sm="12" xs="12" className="mt-3">
                        <div
                          className="filter-buttons"
                          style={{ float: "right" }}
                        >
                          <Button
                            type="button"
                            onClick={() => resetForm()}
                            className="btn btn-danger btn-label simple-form-Reset-btn"
                          >
                            <i className="bx bx-reset bx-flip-horizontal label-icon"></i>
                            Reset
                          </Button>
                          <Button
                            type="submit"
                            // onKeyDown={(e) => handleFilter(e)}
                            onClick={(e) => handleFilter(e)}
                            className="btn btn-success btn-label simple-form-applyfilter-btn mx-2"
                          >
                            <i className="bx bx-filter-alt label-icon"></i>
                            {btnLoader && btnLoader ? (
                              <ButtonSpinner />
                            ) : (
                              "Apply Filter"
                            )}{" "}
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </form>
                </CardBody>
              </Card>
            </Col>
          </Row>
          {/*Table start*/}
          <Row>
            <Col md="12" lg="12" xl="12">
              <Card>
                <CardBody>
                  <div
                    className="d-flex flex-row"
                    style={{ marginTop: "20px" }}
                  >
                    <div className="search-box me-2 mb-2 d-inline-block d-flex flex-row ">
                      <form onSubmit={handleClick} className="d-flex flex-row">
                        <div style={searchBarStyle || null}>
                          <Input
                            type="text"
                            name="searchInput"
                            value={searchInput}
                            onChange={(e) => setSearchInput(e.target.value)}
                            className="form-control"
                            placeholder="Search"
                            style={{ position: "relative" }}
                          />
                          <i
                            className="bx bx-search-alt"
                            style={{
                              position: "absolute",
                              top: "54px",
                              left: "41px",
                              fontSize: "13px",
                            }}
                          />
                        </div>
                        <button
                          className="btn btn-success mx-2"
                          type="submit"
                          style={{
                            background: searchFilter ? "#2ca67a" : "",
                            color: searchFilter ? "#ffffff" : "",
                          }}
                        // onClick={(e) => handleClick()}
                        >
                          <i className="fas fa-search"></i>
                        </button>
                      </form>
                    </div>
                  </div>{" "}
                  {/* <div className="d-flex flex-row">
                    
                    
                  </div> */}
                  <RemotePagination
                    data={unAssignedTable}
                    page={page}
                    sizePerPage={sizePerPage}
                    totalSize={
                      !isEmpty(assigned_details)
                        ? assigned_details.totalDataCount
                        : 0
                    }
                    onTableChange={handleTableChange}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>

        <div className="d-flex justify-content-center mb-5">
          {followupModal && (
            <Modal size="xl" show={followupModal} onHide={handleFollowupClose}>
              <Modal.Header style={{ backgroundColor: "#e40d8c" }}>
                <h5
                  style={{
                    color: "#ffffff",
                    fontWeight: 800,
                    textTransform: "uppercase",
                  }}
                >
                  Followup Details
                </h5>
              </Modal.Header>

              <Modal.Body>
                <Row className="d-flex flex-column">
                  {/* <div>No Records Found</div> */}
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <Table responsive bordered striped>
                      <thead>
                        <tr>
                          <th>S.No</th>
                          <th>Followup No</th>
                          <th>Followup Date</th>
                          <th>Followup Time</th>
                          <th>Followup Mode</th>
                          <th>Followup Reason</th>
                          <th>Followup Remarks</th>
                          <th>Attachment</th>
                        </tr>
                      </thead>
                      <tbody>
                        {!isEmpty(followupDetails) &&
                          followupDetails.length > 0 ? (
                          followupDetails.map((data, index) => {
                            // let slNo = 0
                            //console.log(data, "request from data table leave")
                            const followupDate = !isEmpty(data.followupDate)
                              ? moment(data.followupDate).format("DD-MM-YYYY")
                              : "--"
                            const attachment =
                              !isEmpty(data.attachment) &&
                                data.attachment.length > 0
                                ? data.attachment
                                : []
                            return (
                              <tr key={data._id}>
                                <td>{index + 1}</td>
                                <td>{data.followupNumber}</td>
                                <td>{followupDate}</td>
                                <td>{data.time}</td>
                                <td>{data.followupModeName}</td>
                                <td>{data.followupReasonName}</td>
                                <td>{data.followupRemarks}</td>
                                <td>
                                  <a
                                    onClick={() => {
                                      window.open(attachment, "_blank")
                                    }}
                                  >
                                    <span
                                      style={{
                                        color: "#e40d8c",
                                        textDecoration: "underline",
                                      }}
                                    >
                                      View
                                    </span>
                                  </a>
                                </td>
                              </tr>
                            )
                          })
                        ) : (
                          <>
                            <tr key={0}>
                              <td className="text-align-center" colSpan={8}>
                                No Records Found
                              </td>
                            </tr>
                          </>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="secondary"
                  className="btn btn-danger"
                  data-bs-dismiss="modal"
                  onClick={() => setFollowupModal(false)}
                >
                  Close
                </Button>
              </Modal.Footer>
            </Modal>
          )}
          {checklistModal && (
            <Modal
              size="xl"
              show={checklistModal}
              onHide={handleChecklistClose}
            >
              <Modal.Header style={{ backgroundColor: "#e40d8c" }}>
                <h5
                  style={{
                    color: "#ffffff",
                    fontWeight: 800,
                    textTransform: "uppercase",
                  }}
                >
                  Checklist Details
                </h5>
              </Modal.Header>

              <Modal.Body>
                <Row className="d-flex flex-column">
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <BootstrapTable
                      keyField="checklistDetail"
                      data={checklistDataTable}
                      columns={checklistColumns}
                      responsive
                      striped={true}
                      bordered={true}
                      expandRow={checklistExpandRow}
                    />
                  </Col>
                </Row>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="secondary"
                  className="btn btn-danger"
                  data-bs-dismiss="modal"
                  onClick={() => setChecklistModal(false)}
                >
                  Close
                </Button>
              </Modal.Footer>
            </Modal>
          )}
          {teamModal && (
            <Modal size="xl" show={teamModal} onHide={handleTeamClose}>
              <Modal.Header style={{ backgroundColor: "#e40d8c" }}>
                <h5
                  style={{
                    color: "#ffffff",
                    fontWeight: 800,
                    textTransform: "uppercase",
                  }}
                >
                  Team Scheduling Details
                </h5>
              </Modal.Header>

              <Modal.Body>
                <Row className="d-flex flex-column">
                  {/* <div>No Records Found</div> */}
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <BootstrapTable
                      keyField="serviceDetails"
                      data={teamScheduleDataTable}
                      columns={teamScheduleColumns}
                      responsive
                      striped={true}
                      bordered={true}
                      expandRow={teamScheduleExpandRow}
                    />
                    {/* <Table responsive bordered striped>
                      <thead>
                        <tr>
                          <th style={{ width: "20px" }}>S.No</th>
                          <th>Is Commit</th>
                          <th>Team Type</th>
                          <th>Service No</th>
                          <th>Payment Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        {!isEmpty(teamDetails) && teamDetails.length > 0 ? (
                          teamDetails.map((data, index) => {
                            // let slNo = 0
                            //console.log(data, "request from data table leave")
                            const teamTypeDetails =
                              !isEmpty(data.serviceDetails) &&
                              data.serviceDetails.length > 0
                                ? data.serviceDetails.map(
                                    (data) => data.teamType
                                  )
                                : []
                            const teamType =
                              !isEmpty(teamTypeDetails) &&
                              teamTypeDetails.length > 0
                                ? teamTypeDetails.join(",")
                                : ""
                            const serviceNameDetails =
                              !isEmpty(data.serviceDetails) &&
                              data.serviceDetails.length > 0
                                ? data.serviceDetails.map(
                                    (data) => data.serviceNo
                                  )
                                : []
                            const serviceName =
                              !isEmpty(serviceNameDetails) &&
                              serviceNameDetails.length > 0
                                ? serviceNameDetails.join(",")
                                : ""
                            const paymentStatusDetails =
                              !isEmpty(data.serviceDetails) &&
                              data.serviceDetails.length > 0
                                ? data.serviceDetails.map(
                                    (data) => data.paymentStatus
                                  )
                                : []
                            const paymentStatus =
                              !isEmpty(paymentStatusDetails) &&
                              paymentStatusDetails.length > 0
                                ? paymentStatusDetails.join(",")
                                : ""

                            return (
                              <tr key={data._id}>
                                <td>{index + 1}</td>
                                <td>
                                  <Badge
                                    color={
                                      data.isCommit === true
                                        ? "success"
                                        : "danger"
                                    }
                                    style={{ padding: "6px", fontSize: "12px" }}
                                  >
                                    {data.isCommit === true ? "Yes" : "No"}
                                  </Badge>
                                </td>
                                <td>{teamType}</td>
                                <td>{serviceName}</td>
                                <td>{paymentStatus}</td>
                              </tr>
                            )
                          })
                        ) : (
                          <>
                            <tr key={0}>
                              <td className="text-aling-center" colSpan={5}>
                                No Records Found
                              </td>
                            </tr>
                          </>
                        )}
                      </tbody>
                    </Table> */}
                  </Col>
                </Row>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="secondary"
                  className="btn btn-danger"
                  data-bs-dismiss="modal"
                  onClick={() => setTeamModal(false)}
                >
                  Close
                </Button>
              </Modal.Footer>
            </Modal>
          )}
          {equipmentModal && (
            <Modal
              size="xl"
              show={equipmentModal}
              onHide={handleEquipmentClose}
            >
              <Modal.Header style={{ backgroundColor: "#e40d8c" }}>
                <h5
                  style={{
                    color: "#ffffff",
                    fontWeight: 800,
                    textTransform: "uppercase",
                  }}
                >
                  Equipment Details
                </h5>
              </Modal.Header>

              <Modal.Body>
                <Row className="d-flex flex-column">
                  {/* <div>No Records Found</div> */}
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <BootstrapTable
                      keyField="equipmentDetails"
                      data={equipmentScheduleDataTable}
                      columns={equipmentScheduleColumns}
                      responsive
                      striped={true}
                      bordered={true}
                      expandRow={equipmentScheduleExpandRow}
                    />

                    {/* <Table responsive bordered striped>
                      <thead>
                        <tr>
                          <th>S.No</th>
                          <th>Company</th>
                          <th>Branch</th>
                          <th>Commit</th>
                          <th>Event Date</th>
                          <th>Type</th>
                          <th>Service Name</th>
                          <th>Quantity</th>
                          <th>Total Cost</th>
                        </tr>
                      </thead>
                      <tbody>
                        {!isEmpty(equipmentDetails) &&
                        equipmentDetails.length > 0 ? (
                          equipmentDetails.map((data, index) => {
                            // let slNo = 0
                            //console.log(data, "request from data table leave")
                            const eventDate = !isEmpty(data.eventdate)
                              ? moment(data.eventdate).format("DD-MM-YYYY")
                              : "--"
                            const serviceNameDetails =
                              !isEmpty(data.equipmentDetails) &&
                              data.equipmentDetails.length > 0
                                ? data.equipmentDetails.map(
                                    (data) => data.serviceName
                                  )
                                : []
                            const serviceName =
                              !isEmpty(serviceNameDetails) &&
                              serviceNameDetails.length > 0
                                ? serviceNameDetails.join(",")
                                : ""
                            const typeDetails =
                              !isEmpty(data.equipmentDetails) &&
                              data.equipmentDetails.length > 0
                                ? data.equipmentDetails.map((data) => data.type)
                                : []
                            const type =
                              !isEmpty(typeDetails) && typeDetails.length > 0
                                ? typeDetails.join(",")
                                : ""

                            const companyNameDetails =
                              !isEmpty(data.equipmentDetails) &&
                              data.equipmentDetails.length > 0
                                ? data.equipmentDetails.map(
                                    (data) => data.companyName
                                  )
                                : []
                            const companyName =
                              !isEmpty(companyNameDetails) &&
                              companyNameDetails.length > 0
                                ? companyNameDetails.join(",")
                                : ""

                            const branchNameDetails =
                              !isEmpty(data.equipmentDetails) &&
                              data.equipmentDetails.length > 0
                                ? data.equipmentDetails.map(
                                    (data) => data.branchName
                                  )
                                : []
                            const branchName =
                              !isEmpty(branchNameDetails) &&
                              branchNameDetails.length > 0
                                ? branchNameDetails.join(",")
                                : ""

                            const qtyDetails =
                              !isEmpty(data.equipmentDetails) &&
                              data.equipmentDetails.length > 0
                                ? data.equipmentDetails.map((data) => data.qty)
                                : []
                            const qty =
                              !isEmpty(qtyDetails) && qtyDetails.length > 0
                                ? qtyDetails.join(",")
                                : ""

                            const totalDetails =
                              !isEmpty(data.equipmentDetails) &&
                              data.equipmentDetails.length > 0
                                ? data.equipmentDetails.map(
                                    (data) => data.total
                                  )
                                : []
                            const total =
                              !isEmpty(totalDetails) && totalDetails.length > 0
                                ? totalDetails.join(",")
                                : ""

                            return (
                              <tr key={data._id}>
                                <td>{index + 1}</td>
                                <td>{companyName}</td>
                                <td>{branchName}</td>
                                <td>
                                  <Badge
                                    color={
                                      data.isCommit === true
                                        ? "success"
                                        : "danger"
                                    }
                                    style={{ padding: "6px", fontSize: "12px" }}
                                  >
                                    {data.isCommit === true ? "Yes" : "No"}
                                  </Badge>
                                </td>
                                <td>{eventDate}</td>
                                <td>{type}</td>
                                <td>{serviceName}</td>
                                <td>{qty}</td>
                                <td>{total}</td>
                              </tr>
                            )
                          })
                        ) : (
                          <>
                            <tr key={0}>
                              <td className="text-aling-center" colSpan={5}>
                                No Records Found
                              </td>
                            </tr>
                          </>
                        )}
                      </tbody>
                    </Table> */}
                  </Col>
                </Row>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="secondary"
                  className="btn btn-danger"
                  data-bs-dismiss="modal"
                  onClick={() => setEquipmentModal(false)}
                >
                  Close
                </Button>
              </Modal.Footer>
            </Modal>
          )}
          {btnLoading ? (
            <Modal
              show={btnLoading}
              style={{ width: "6.7%", margin: "18% 50%" }}
            >
              <Modal.Body>
                <Spinner
                  as="span"
                  animation="grow"
                  size="lg"
                  role="status"
                  aria-hidden="true"
                  variant="success"
                  className="mx-2"
                  color="success"
                />
                {/* <span>Loading...</span> */}
              </Modal.Body>
            </Modal>
          ) : (
            ""
          )}
          {downloadLoading ? (
            <Modal
              show={downloadLoading}
              style={{ width: "6.7%", margin: "18% 50%" }}
            >
              <Modal.Body>
                <Spinner
                  as="span"
                  animation="grow"
                  size="lg"
                  role="status"
                  aria-hidden="true"
                  variant="success"
                  className="mx-2"
                  color="success"
                />
                {/* <span>Loading...</span> */}
              </Modal.Body>
            </Modal>
          ) : (
            ""
          )}
        </div>
      </div>
      <ToastContainer
        position="top-right"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </React.Fragment>
  )
}

EcAssignedList.propTypes = {
  dispatch: PropTypes.func,
  searchProps: PropTypes.func,
  baseProps: PropTypes.any,
  searchBarStyle: PropTypes.any,
  csvProps: PropTypes.any,
  name: PropTypes.any,
  FlagExportExcel: PropTypes.any,
  location: PropTypes.any,
  data: PropTypes.array.isRequired,
  page: PropTypes.number.isRequired,
  loading: PropTypes.bool.isRequired,
  totalSize: PropTypes.number.isRequired,
  sizePerPage: PropTypes.number.isRequired,
  onTableChange: PropTypes.func.isRequired,
  onSearch: PropTypes.func,
  onExport: PropTypes.func,

  // enableTableFilter: PropTypes.any,
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}
const mapStateToProps = () => ({
  // employee: state.employeeRequest.employee,
})

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(EcAssignedList)
)
